module.exports = __webpack_public_path__ + "img/logo.0fa57b9e.png";